// The machine's commands on the session socket, as the contract's Up
// frames: one TurnStart with the chat mode, the device's rate named
// once as an AudioFormat before the first audio, the audio as s16le
// bytes, the turn's end as an Over, a drop as a TurnCancel. Pure in
// shape (a command to a message), so the mapping is testable; the
// sending itself is one call.
import { create } from "@bufbuild/protobuf";
import { TurnMode, UpSchema, type Up } from "@/gen/psypen/v1/session_pb";
import type { TurnCmd } from "@/talk/turns";

export function toUp(c: TurnCmd): Up {
  switch (c.t) {
    case "turnStart":
      return create(UpSchema, {
        msg: {
          case: "turnStart",
          value: { turn: c.turn, mode: TurnMode.CHAT, held: TurnMode.UNSPECIFIED },
        },
      });
    case "format":
      return create(UpSchema, { msg: { case: "audioFormat", value: { rate: c.rate } } });
    case "audio":
      return create(UpSchema, { msg: { case: "audio", value: c.pcm } });
    case "over":
      return create(UpSchema, { msg: { case: "over", value: {} } });
    case "cancel":
      return create(UpSchema, { msg: { case: "turnCancel", value: { turn: c.turn } } });
  }
}
